// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2032) return "static/chunks/2032-c496000a91f92b33.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2991":"b4b81572c9ecff8e","4037":"5bf30862e5712b92","4080":"d06fd1fc8acb661a","5757":"f85bcad6cae92e9e","8315":"a893f291984cb8bd","9667":"e68a7641c5691bad"}[chunkId] + ".js";
};